// extracted by mini-css-extract-plugin
module.exports = {"container":"TransCard_container__14ZVj"};